import React from 'react';
import { useDarkMode } from '../darkmode/DarkModeContext';

const PromoOffers = () => {
  const { isDarkMode } = useDarkMode();

  const promoOffers = [
    {
      title: 'Gratis Pemasangan',
      description: 'Coba gratis pemasangan paket internet dan semua paket TV & IPTV',
      icon: '/image/produk TV/bubble.png', // Gambar lokal
      color: 'from-[#1E9B4C] to-[#1E9B4C]' // Update the blue color
    },
    {
      title: 'Bundle Internet + TV',
      description: 'Hemat 30% dengan paket bundling internet + TV',
      icon: '/image/produk TV/bubble.png', // Gambar lokal
      color: 'from-[#1E9B4C] to-[#1E9B4C]' // Update the blue color
    },
    {
      title: 'Upgrade Gratis Set-Top Box',
      description: 'Set-top box 4K gratis untuk kontrak 24 bulan',
      icon: '/image/produk TV/bubble.png', // Gambar lokal
      color: 'from-[#1E9B4C] to-[#1E9B4C]' // Update the blue color
    },
    {
      title: 'Multi-Room Package',
      description: 'Tambahan receiver untuk kamar lain hanya Rp 50rb',
      icon: '/image/produk TV/bubble.png', // Gambar lokal
      color: 'from-[#1E9B4C] to-[#1E9B4C]' // Update the blue color
    }
  ];

  return (
    <section 
      className={`py-16 ${isDarkMode ? 'bg-gray-900' : 'bg-gray-100'}`}
      style={{  
        backgroundImage: "url('https://telnet.net.id/assets/bg.png')",
        backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',
        backgroundBlendMode: 'overlay',
      }}
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className={`text-4xl font-bold mb-4 ${isDarkMode ? 'text-green-50' : 'text-gray-900'}`}>
            Promo Paket Internet & IPTV Spesial
          </h2>
          <p className={`text-xl ${isDarkMode ? 'text-gray-300' : 'text-gray-600'} max-w-2xl mx-auto`}>
            Dapatkan penawaran terbaik untuk pengalaman menonton yang tak terlupakan
          </p>
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {promoOffers.map((offer, index) => (
            <div key={index} 
              className={`promo-card bg-gradient-to-br ${offer.color} rounded-2xl p-6 text-white flex flex-col h-full`}>
              <div className="mb-4 flex justify-center">
                <img 
                  src={offer.icon} 
                  alt={offer.title} 
                  className="w-full h-auto object-contain" // Responsive image size
                />
              </div>
              <h3 className={`text-xl font-bold mb-2 text-center ${isDarkMode ? 'text-green-50' : 'text-gray-900'}`}>{offer.title}</h3>
              <p className={`text-gray-100 text-center flex-grow ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>{offer.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromoOffers;